import { useState } from "react";

import { PopupTemplate } from "templates/PopupTemplate";
import { IAddress } from "interfaces/Address";

import { ICoord } from "services/CordsService";
import { useEffect } from "react";
import { getByIdAddressService } from "services/AddressServices";
import { fireToast } from "services/sweetAlertConfig";
import { StorePopupSkeleton } from "./skeleton";

type Props = {
  coords: ICoord;
  onClose: () => void;
};

function StorePopup({ coords, onClose }: Props) {
  const [store, setStore] = useState<IAddress | undefined>();

  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    fetchStore();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function fetchStore() {
    await getByIdAddressService(coords.id)
      .then((response) => {
        setStore(response.item);
        setIsLoading(false);
      })
      .catch(() => {
        onError();
      });
  }

  function copy(type: "id" | "coords") {
    let clipboard = `${coords.coords.x}, ${coords.coords.y}`;
    let toast = "Coordenadas copiadas";

    if (type === "id") {
      clipboard = coords.id;
      toast = "ID do estabelecimento copiado";
    }

    navigator.clipboard.writeText(clipboard);
    fireToast(toast, 2000);
  }

  function onError() {
    onClose();
    setStore(undefined);
    fireToast(
      "Não foi possível recuperar as informações desse estabelecimento",
      2000
    );
  }
  if (isLoading) return <StorePopupSkeleton />;

  return (
    <PopupTemplate
      title={store?.name || "Nenhum nome atribuido"}
      subtitle={`${coords.coords.x}, ${coords.coords.y}`}
      onPopupClose={() => {
        onClose();
      }}
      renderButtons={
        <div>
          <button onClick={() => copy("id")}>
            Copiar ID do estabelecimento
          </button>
          <button onClick={() => copy("coords")}>Copiar coordenadas</button>
        </div>
      }
    />
  );
}

export { StorePopup };
